export default "__VITE_ASSET__b40gH10g__"